'use client'
import { useLocale } from '~/contexts/LocaleContext'
import { getTranslation } from '~/lib/i18n-utils'
import BookingMobile from './mobile'
import BookingDesktop from './desktop'
import { useDevice } from '~/hooks/use-device'
import { ScrollTracker } from '../analytics/ScrollTracker'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
export default function Booking() {
  const { locale } = useLocale()
  const t = getTranslation(locale)
  const { isMobile } = useDevice()
  const searchParams = useSearchParams()
  const voucherCode = searchParams.get('voucherCode') || ''

  useEffect(() => {
    if (voucherCode) {
      window.sessionStorage.setItem('voucherCode', voucherCode)
    }
  }, [])

  return (
    <>
      {isMobile ? <BookingMobile /> : <BookingDesktop />}
      <ScrollTracker thresholds={[50, 75, 100]} />
    </>
  )
}
